const { requestManager } = require('../../requestManager');

const { API_PATH } = require('../../config/config');

class ConfigMastaApi {
  /**
   * カテゴリに合致する設定一覧を取得する
   * @param {string} category カテゴリ名
   * @param {object} sortValue ソート条件
   * @return 条件に合致する設定一覧
   */
  findByCategory = async (category = '', sortValue = 1) => {
    const filter = { enable: true, 'conf.category': category };
    const sort = { 'conf.order': sortValue };
    const params = { filter, sort };

    // try {
    const response = await requestManager.get(`${API_PATH}/masta/config`, params);

    // FIXME: configMasterの返答方法を変更してこちらも変更する
    const result = [];
    for (let i = 0; i < response.data.length; i += 1) {
      const { conf = '' } = response.data[i];
      result.push(conf);
    }

    return result;
    // } catch (err) {
    //   return false;
    // }
  };

  /**
   * 設定値コードに合致する設定を取得する
   * @param {string} confCd 設定値コード
   * @param {object} sortValue ソート条件
   * @return 条件に合致する設定
   */
  findByConfCd = async (confCd = '', sortValue = 1) => {
    const filter = { enable: true, 'conf.conf_cd': confCd };
    const sort = { 'conf.order': sortValue };
    const params = { filter, sort };

    // try {
    const response = await requestManager.get(`${API_PATH}/masta/config/r`, params);

    // if (response.data.length !== 0) {
    const { conf = '' } = response.data[0];
    return conf;
    // }
    // } catch (err) {
    //   return false;
    // }

    // return false;
  };

  /**
   * カテゴリと値でラベルを取得
   * @param {*} category
   * @param {*} value
   * @returns
   */
  findByCategoryAndValue = async (category = null, value = null) => {
    const filter = {
      'conf.category': category,
      'conf.value': value,
      enable: true,
    };
    const params = { filter };
    const response = await requestManager.get(`${API_PATH}/masta/config`, params);

    const { conf = '' } = response.data[0];
    const { label = '' } = conf;

    return label;
  };
}

export default new ConfigMastaApi();
